import { Global } from '@emotion/core';
import { resetStyles } from './resetStyles';
import { globalStyles } from './globalStyles';

export function GlobalStyles() {
  return <Global styles={[resetStyles, globalStyles]} />;
}
